import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
    EnvironmentProviders,
    inject,
    isDevMode,
    makeEnvironmentProviders,
    provideAppInitializer,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslocoConfig, provideTransloco } from '@jsverse/transloco';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { REPOSITORY_BASE_URL_TOKEN, SecureLocalStorageService } from 'shared';

import { HeaderConfig } from './core';
import { HeaderInitializerFactory } from './core/factories/header-initializer.factory';
import { authInterceptorFn } from './core/interceptors/auth.interceptor';
import { HeaderSettingsService } from './core/services/internal';
import { provideAuthentication } from './providers/authentication.provider';

const defaultTranslocoConfig = {
    availableLangs: ['en', 'nl'],
    defaultLang: 'en',
    fallbackLang: 'en',
};

export type HeaderLanguageConfig = Pick<TranslocoConfig, 'availableLangs' | 'defaultLang' | 'fallbackLang'>;

export function provideOneGoHeader(
    mapSettings: (appSettings: unknown) => HeaderConfig,
    headerLanguageConfig: HeaderLanguageConfig
): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAnimationsAsync(),
        provideOAuthClient(),
        { provide: OAuthStorage, useClass: SecureLocalStorageService },
        provideHttpClient(withFetch(), withInterceptors([authInterceptorFn]), withInterceptorsFromDi()),
        provideAppInitializer(() => HeaderInitializerFactory(inject(HeaderSettingsService), mapSettings)()),
        provideAuthentication(),
        {
            provide: REPOSITORY_BASE_URL_TOKEN,
            useFactory: () => inject(HeaderSettingsService).settingsSubject,
        },
        provideTransloco({
            config: {
                ...defaultTranslocoConfig,
                ...headerLanguageConfig,
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
        }),
    ]);
}

export function getRedirectUrl(): string {
    return [globalThis.location.origin, globalThis.location.pathname].filter(Boolean).join('/').replace(/\/\/$/, '/');
}
